// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3pIn0","right":"Footer_right__2Xb-D","buttons":"Footer_buttons__3E-Zf"};